export const environment = {
  production: false,
  version: "7.2.x",
  reCAPTCHA: {
    publicKey: "6LeYBkYsAAAAAAwVk5d9ZkiGSkivsuTds4yspyq8"
  },
  firebase: {
    apiKey: "AIzaSyDOj_2AkMnqeCFWnW5W2iPYl62FMZqFB8c",
    authDomain: "ez7v2-prod.firebaseapp.com",
    projectId: "ez7v2-prod",
    storageBucket: "ez7v2-prod.firebasestorage.app",
    messagingSenderId: "504673338970",
    appId: "1:504673338970:web:29c5fa52389b963e40ba63",
    measurementId: "G-XZF86CPMYR",
    vapidKey: "BPWbrk2wdEDNu07uuFeuVmjFY91_-UurzcdvYipg5XQ2qjgFTjM23X99GHBOMoJILNq3m4fS3a2dvKzjq82ixvU"
  },
  license: {
    max_day_warn: 15
  },
  backend: {
    host: "https://portal7.easyfo.com",
    timeout_in_sec: 30000,
    user: {
      baseUrl: "/api/v1/users",
      public_key: "-----BEGIN PUBLIC KEY-----\nMIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQBo5fpB9jFsQ5KzSyC8Bihq\nE7J4iwBdGarxApPKWFs+c3ELzQx7v6C04PSGWU0kDaQntTXffMb+1UyLh8SoZKo4\nV95oiJ6atkTOxSAWvNwSunpRrSoAZUTwYBzsw36GZnatUL+yCVy1ZajygxlIj6b6\nZcvZ/nIHH00oltbuZ8oAWzcX7id2Vg2WwbCAuBQZ6ETpQm8v1xD9MAjU7NsJxDPQ\nCz4yEQD7XfuICq0BYHRKTPkdTOmmfmSI39IRAMRKWqHgjiCqE2VD39d3ev7T0COW\nZS9Wnb/UTZrE5rRNYJopgM36TH0hW1sSM8f7YgaJsAGGCFB/YhXqbnO04hkoBtxz\nAgMBAAE=\n-----END PUBLIC KEY-----"
    },
    hotel: {
      baseUrl: "/api/v1/hotels"
    },
    guest: {
      baseUrl: "/api/v1/guests"
    },
    front: {
      baseUrl: "/api/v1/front"
    },
    centralized: {
      baseUrl: "/api/v1/centralized"
    },
    report: {
      baseUrl: "/api/v1/reports"
    }
  },
  alert_sweet: {
    title: "title-sweet",
    htmlContainer: "html-sweet",
    confirmButton: "confirm-sweet",
    cancelButton: "cancel-sweet",
    popup: "popup-sweet",
    closeButton: "close-sweet",
    icon: "icon-sweet",
    actions: "action-sweet"
  }
};